
import React, { useContext, useState, useRef, useEffect, useCallback, forwardRef, useImperativeHandle } from 'react';
import axios from 'axios';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { Notifications, Help, ArrowDropDown, Upload, UploadFileOutlined, CloseIcon, CloseRounded, } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Avatar,
  Button,
  Badge,
  Box,
  Select,
  Divider,
  Drawer,
  TextField,
  InputLabel,
  FormControl,
  FormControlLabel,
  Checkbox,
  InputAdornment,
  Paper, Tabs,
} from '@mui/material';

import Search from '@mui/icons-material/Search';
import Tab from '@mui/material/Tab';
import { formatDistanceToNow, parseISO } from "date-fns";
import {
    CaseDocumentsModel, caseDocumentsModel,
    TextFieldWithIconButton,
    SearchTextFieldCustom,
    DocumentUtility,
    UtilityLibrary,
    caseDataService,
    batchDataService,
    BusinessUtility,
    ApiManager,
    sessionService,
    SessionManager,
    EnumUtility,
    LoggerUtility,
    ConfirmationDialog,
    NotificationDialog,
    FetchControls,
    DeterminePermissions,
    DocumentCaseDetail,
    WorkflowActivities,
    CustomerServiceContacts,
    LegalCaseDetail,
    WorkflowsCaseDetail,
} from '../../../components/ComponentsLibrary';


const CaseDetailManager = forwardRef((props, ref) => {

    const {
        PrimaryID,
        noCase,
        caseWorkflowID = null,
        SelectedCaseDetailID,
        HandleNotificationDialog,
        SetSelectedDoc,
        SelectedDoc,
        displayDocumentInternally,
        HandlePDFViewerError,
        persistViewerPreferences = false
    } = props;

    // Expose the method to the parent via ref
    useImperativeHandle(ref, () => ({
        onLoadCustomerServiceContactsByCaseID,
    }));

    const errorFormName = "Case Detail - Manager";


    const caseDetailComponentMap = {
        'DocumentCaseDetail': DocumentCaseDetail,
        'WorkflowActivityCaseDetail': WorkflowActivities,
        'CustomerServiceContacts': CustomerServiceContacts,
        'LegalCaseDetail': LegalCaseDetail,
        'WorkflowsCaseDetail': WorkflowsCaseDetail,
    };

    const caseDetailOptions = {
        Document: { id: 1, label: "Documents", value: "DocumentCaseDetail" },
        WorkflowActivity: { id: 2, label: "Workflow Activities", value: "WorkflowActivityCaseDetail" },
        CustomerServiceContacts: { id: 3, label: "Customer Service Contacts", value: "CustomerServiceContacts" },
        Workflows: { id: 4, label: "Workflows", value: "WorkflowsCaseDetail" },
    };

    const documentRef = useRef(null);
    const workflowActivityRef = useRef(null);
    const customerServiceContactRef = useRef(null);
    const legalRef = useRef(null);
    const workflowRef = useRef(null);


    //=======================================================================
    //  - Begin
    //=======================================================================

    const simulateAsyncDelay = async () => {
        await new Promise((resolve) => setTimeout(resolve, 0));
    }

    // Function to get the currently active ref
    const getActiveRef = () => {
        switch (SelectedCaseDetailID) {
            case caseDetailOptions.Document.value:
                return documentRef;

            case caseDetailOptions.WorkflowActivity.value:
                return workflowActivityRef;

            case caseDetailOptions.CustomerServiceContacts.value:
                return customerServiceContactRef;

            /* case caseDetailOptions.Legal.value:
                return legalRef; */

            case caseDetailOptions.Workflows.value:
                return workflowRef;

            default:
                return documentRef;
        }
    };

    const activeRef = getActiveRef();

    const onLoadCustomerServiceContactsByCaseID = async () => {
        try {
            const caseID = PrimaryID;
            
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "onLoadCustomerServiceContactsByCaseID");
        }
    };

    
        const documentCaseDetailPanelSelection = (docPanelID) => {
            try {
                if (documentRef.current) {
                    // Call the child method with parameters               
                    documentRef.current.onLoadDocumentsByCaseID();
                }
            }
            catch (error) {
                throw LoggerUtility.ProcessErrorData(error, "documentCaseDetailPanelSelection", {});
            }
        };
    
        const workflowActivityCaseDetailPanelSelection = (workflowPanelID) => {
            try {
                if (workflowActivityRef.current) {
                    // Call the child method with parameters               
                    workflowActivityRef.current.onLoadWorkflowActivitiesByCaseID(true);
                }
            }
            catch (error) {
                throw LoggerUtility.ProcessErrorData(error, "workflowActivityCaseDetailPanelSelection", {});
            }
    
        };
    
        const customerServiceContactsCaseDetailPanelSelection = (contactsPanelID) => {
            try {
                if (customerServiceContactRef.current) {
                    // Call the child method with parameters               
                    customerServiceContactRef.current.onLoadCustomerServiceContactsByCaseID();
                }
            }
            catch (error) {
                throw LoggerUtility.ProcessErrorData(error, "customerServiceContactsCaseDetailPanelSelection", {});
            }
    
        };
    
        const legalCaseDetailPanelSelection = (legalPanelID) => {
            try {
                if (legalRef.current) {
                    // Call the child method with parameters               
                    legalRef.current.onLoadLegalDetailByCaseID();
                }
            }
            catch (error) {
                throw LoggerUtility.ProcessErrorData(error, "legalCaseDetailPanelSelection", {});
            }
    
        };
    
        const workflowsCaseDetailPanelSelection = (workflowsPanelID) => {
            try {
                if (workflowRef.current) {
                    // Call the child method with parameters               
                    workflowRef.current.onLoadWorkflowsByCaseID();
                }
            }
            catch (error) {
                throw LoggerUtility.ProcessErrorData(error, "workflowsCaseDetailPanelSelection", {});
            }
    
        };
    
        const caseDetailPanelSelection = useCallback(() => {
            console.log("🔍 caseDetailPanelSelection called with:", SelectedCaseDetailID);
            try {
                const selectedPanelID = SelectedCaseDetailID;                
    
                switch (selectedPanelID) {
    
                    case caseDetailOptions.Document.value:
                        documentCaseDetailPanelSelection(selectedPanelID);
                        break;
    
                    case caseDetailOptions.WorkflowActivity.value:
                        console.log("📋 Calling workflowActivityRef.current:", workflowActivityRef.current);
                        workflowActivityCaseDetailPanelSelection(selectedPanelID);
                        break;
    
                    case caseDetailOptions.CustomerServiceContacts.value:
                        customerServiceContactsCaseDetailPanelSelection(selectedPanelID);
                        break;
    
                    /* case caseDetailOptions.Legal.value:
                        legalCaseDetailPanelSelection(selectedPanelID);
                        break; */
    
                    case caseDetailOptions.Workflows.value:
                        workflowsCaseDetailPanelSelection(selectedPanelID);
                        break;
    
                    default:
                        break;
                }
            }
            catch (error) {
                throw LoggerUtility.ProcessErrorData(error, "caseDetailPanelSelection", {});
            }
            
        }, [SelectedCaseDetailID]);



    //=======================================================================
    //  - End
    //=======================================================================


    //=======================================================================
    // Tabs Feature - Begin
    //=======================================================================


    //=======================================================================
    // Tabs Feature - End
    //=======================================================================

    const DynamicComponent = SelectedCaseDetailID ? caseDetailComponentMap[SelectedCaseDetailID] : null;


    const mainCaseDetailContent = (
        <div style={{ width: '100%' }}>

            {DynamicComponent && (
                <DynamicComponent
                    key={SelectedCaseDetailID}
                    PrimaryID={PrimaryID}
                    noCase={noCase}
                    ref={activeRef}
                    onComponentMount={caseDetailPanelSelection}
                    HandleNotificationDialog={SelectedCaseDetailID === "DocumentCaseDetail" ? HandleNotificationDialog : undefined}
                    SetSelectedDoc={SelectedCaseDetailID === "DocumentCaseDetail" ? SetSelectedDoc : undefined}
                    displayDocumentInternally={SelectedCaseDetailID === "DocumentCaseDetail" ? displayDocumentInternally : undefined}
                    HandlePDFViewerError = {SelectedCaseDetailID === "DocumentCaseDetail" ? HandlePDFViewerError : undefined}
                    SelectedDoc={SelectedCaseDetailID === "DocumentCaseDetail" ? SelectedDoc : undefined}
                    persistViewerPreferences={SelectedCaseDetailID === "DocumentCaseDetail" ? persistViewerPreferences : undefined}
                    caseWorkflowID = {caseWorkflowID}
                />
            )}

        </div>
    );



    return (
        <div style={{ height: '100%' }}>
            {mainCaseDetailContent}
        </div>
    );
});

export default CaseDetailManager;


